export default __webpack_public_path__ + "static/media/modeling_blue.png";